import React, { forwardRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'
import { useEntities } from 'cityads-v3/hooks/entities'
import { InternalAccountList } from 'cityads-v3/types/internalAccount'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Emoji from 'cityads-v3/components/Emoji/Emoji'
import Typography from '@mui/material/Typography'

import AccountParam from './AccountParam'

import classes from './Payments.scss'

const CURRENCY_FLAG: Record<string, string> = {
  RUB: ':flag_russia:',
  USD: ':flag_united_states:',
  EUR: ':flag_eurounion:',
  BRL: ':flag_brazil:',
  PLN: ':flag_poland:',
  VND: ':flag_vietnam:',
  UAH: ':flag_ukraine:',
  KZT: ':flag_kazakhstan:',
  GBP: ':flag_united_kingdom:',
  CNY: ':flag_china:',
  MXN: ':flag_mexico:',
  MYR: ':flag_malaysia:',
  IDR: ':flag_indonesia:',
}

export type AccountsRefType = {
  reload: () => void
}

export function Accounts(props: unknown, ref: React.RefObject<AccountsRefType>): JSX.Element {
  const { t } = useTranslation(['Payments'])
  const [accounts, isLoading, , load] = useEntities<InternalAccountList>('internalAccounts', null, true)

  useImperativeHandle(ref, () => ({
    reload: load,
  }), [load])

  if (isLoading) {
    return (
      <div className={classes.preloaderContainer}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <div className={classes.accountsContainer}>
      {accounts?.internalAccount?.map(({ id, currency_code, balance_available, hold_adv_amount }) => (
        <Card key={id}>
          <CardContent>
            <div className={classes.currencyName}>
              <Typography variant="h6">
                {currency_code}
              </Typography>
              {CURRENCY_FLAG[currency_code] ? (
                <Emoji
                  code={CURRENCY_FLAG[currency_code]}
                  size={20}
                />
              ) : null}
            </div>

            <div>
              <AccountParam
                title    = {t('balance.holdAdvertiser')}
                value    = {hold_adv_amount}
                currency = {currency_code}
              />
              <AccountParam
                className = {classes.accountParamTotal}
                title     = {t('balance.available')}
                value     = {balance_available}
                currency  = {currency_code}
              />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

export default forwardRef(Accounts)
